import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ConfigProvider } from 'antd';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';
import './index.less';

ReactDOM.render(
    <HashRouter>
        <ConfigProvider locale={locale}>
            <App />
        </ConfigProvider>
    </HashRouter>
    ,
    document.getElementById('root')
);

reportWebVitals();
